import type { User } from '@metadevprofile/shared';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/common/redux/store';

export interface ImpersonationState {
  active: boolean;
  targetUser: User | null;
  returnTo: string | null;
  adminAccessToken: string | null;
  adminRefreshToken: string | null;
  starting: boolean;
}

const initialState: ImpersonationState = {
  active: false,
  targetUser: null,
  returnTo: null,
  adminAccessToken: null,
  adminRefreshToken: null,
  starting: false,
};

interface StartImpersonationSessionPayload {
  targetUser: User;
  returnTo: string | null;
  adminAccessToken: string | null;
  adminRefreshToken: string | null;
}

const impersonationSlice = createSlice({
  name: 'impersonation',
  initialState,
  reducers: {
    setStarting: (state, action: PayloadAction<boolean>) => {
      state.starting = action.payload;
    },
    startImpersonationSession: (state, action: PayloadAction<StartImpersonationSessionPayload>) => {
      state.active = true;
      state.targetUser = action.payload.targetUser;
      state.returnTo = action.payload.returnTo;
      state.adminAccessToken = action.payload.adminAccessToken;
      state.adminRefreshToken = action.payload.adminRefreshToken;
    },
    resetImpersonation: () => initialState,
  },
});

export const { setStarting, startImpersonationSession, resetImpersonation } = impersonationSlice.actions;
export const impersonationReducer = impersonationSlice.reducer;

export const selectImpersonationActive = (state: RootState): boolean => state.impersonation.active;
export const selectImpersonationTargetUser = (state: RootState): User | null => state.impersonation.targetUser;
export const selectImpersonationReturnTo = (state: RootState): string | null => state.impersonation.returnTo;
export const selectImpersonationStarting = (state: RootState): boolean => state.impersonation.starting;
export const selectImpersonationAdminTokens = (
  state: RootState,
): { accessToken: string | null; refreshToken: string | null } => ({
  accessToken: state.impersonation.adminAccessToken,
  refreshToken: state.impersonation.adminRefreshToken,
});
